module.exports = "<p>\n  issues works!\n</p>\n"